import tippy, {followCursor} from 'tippy.js';

export const TooltipBehavior = (superClass) => class extends superClass {
  static get properties() {
    return {
      _tooltipInstances: {type: Array},
      _tooltipDynamicObservers: {type: Array},
      _tooltipCaptionPropertyName: {type: String}
    };
  }

  constructor() {
    super();
    this._tooltipInstances = [];
    this._tooltipDynamicObservers = [];
  }

  #observer;

  // Support LIT
  updated(changedProperties) {
    super.updated(changedProperties);

    if (changedProperties?.has(this._tooltipCaptionPropertyName)) {
      this.#observer(this[this._tooltipCaptionPropertyName]);
    }
  }

  connectedCallback() {
    super.connectedCallback();

    if (!this._tooltipInstances) {
      this._tooltipInstances = [];
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this._tooltipInstances) {
      for (const tooltip of this._tooltipInstances) {
        tooltip.instance.destroy();
        tooltip.instance = null;
      }
    }
    this._tooltipInstances = null;

    if (this._tooltipDynamicObservers?.length) {
      for (const observer of this._tooltipDynamicObservers) {
        this._removePropertyEffect(observer.property, observer.type, observer.effect);
      }
      this._tooltipDynamicObservers = null;
    }
  }

  addTooltip(element, captionPropertyName, options = {}) {
    this._tooltipCaptionPropertyName = captionPropertyName;
    const defaultOptions = {
      theme: 'material',
      arrow: false,
      offset: [0, 3],
      duration: 50,
      content: this[captionPropertyName],
      placement: 'bottom',
      trigger: 'mouseenter'
    };
    if (options.followCursor) {
      options.plugins = [followCursor];
    }
    const instance = tippy(element, Object.assign(defaultOptions, options));
    this._tooltipInstances.push({element, captionPropertyName, instance});

    if (captionPropertyName) {
      if (!this[captionPropertyName]) {
        instance.disable();
      }

      this.#observer = (newValue) => {
        if (newValue) {
          instance.setContent(newValue);
          instance.enable();
        } else {
          instance.disable();
        }
      };

      // Support Polymer
      if (this._createPropertyObserver) {
        this._createPropertyObserver(captionPropertyName, this.#observer, false);
        if (!this._tooltipDynamicObservers) {
          this._tooltipDynamicObservers = [];
        }
        this._tooltipDynamicObservers.push({
          property: captionPropertyName,
          type: this.PROPERTY_EFFECT_TYPES.OBSERVE,
          effect: this.#observer
        });
      }
    }

    return instance;
  }

  getTooltipInstance(element) {
    if (!this._tooltipInstances) {
      return;
    }
    const tooltip = this._tooltipInstances.find(tooltip => (tooltip.element === element));
    return tooltip && tooltip.instance;
  }
};